/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-form-field[_ngcontent-%COMP%]{width:100%;margin-top:10px}.detail[_ngcontent-%COMP%]{height:100%}.margin-right[_ngcontent-%COMP%]{margin-right:10px}.primary-color[_ngcontent-%COMP%]{color:#125f5b}.template-list-button[_ngcontent-%COMP%]{cursor:pointer}.draft[_ngcontent-%COMP%]{color:#ffd014}.archived[_ngcontent-%COMP%]{color:#2680eb}.live[_ngcontent-%COMP%]{color:#02b500}"];
export { styles as styles };
